// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"167":"e2c60ff3","718":"c11b726d","927":"f85b11ac"}[chunkId] + ".js";
};